var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vc-donut',{staticClass:"board-donut-chart",attrs:{"size":_vm.size || 50,"unit":"px","thickness":_vm.thickness || 16,"sections":[
    { value: _vm.correctCount, color: '#66FFBD' }, 
    { value: _vm.wrongCount, color: '#DC5A5A' }
  ],"total":_vm.totalCount || 1}},[(_vm.slotInUse)?_vm._t("default"):_c('p',[_vm._v(_vm._s(_vm.totalCount))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }